import { IconButton } from '@chakra-ui/button'
import { HStack, Link } from '@chakra-ui/layout'
import { Tooltip } from '@chakra-ui/react'
import React, { createElement, useMemo } from 'react'

import { platforms } from '../adminComponents/FieldEditors/SocialLinksEditor'
import Icon from './Blocks/Icon'

const handleLink = (link, pttn, isEmail) => {
  if (!link) return ''
  if (isEmail) {
    return link.startsWith('mailto:') ? link : `mailto:${link}`
  }
  if (link.startsWith('@')) return pttn.replace('xxx', link.substring(1))
  return link.startsWith('http') ? link : `https://${link}`
}

const SocialLinks = ({ links, style, variant, isEditing }) => {
  // console.log(links)
  return (
    <HStack>
      {platforms.map((plat) => {
        const l = links?.[plat.value]
        return l && (
          <Tooltip label={plat.label} key={plat.value}>
            <IconButton
              colorScheme="primary"
              variant={variant}
              as={!isEditing && Link}
              href={handleLink(l, plat.pttn, plat.value === 'email')}
              isExternal
              icon={createElement(Icon, { icon: plat.value, size: '1.5em' })}
              color={style?.color}
              bg={style?.bg}
              _hover={{
                bg: style?.hoverBg
              }}
              _active={{
                bg: style?.activeBg
              }}
            />
          </Tooltip>
        )
      })}
    </HStack>
  )
}

SocialLinks.defaultProps = {
  variant: 'solid',
}

export default SocialLinks
